import { message, Upload } from "antd";
import React from "react";
import { FiUploadCloud } from "react-icons/fi";

const apis = {
  "Money refund LT": "/api/v1/money_returns?country_code=LT",
  "Money refund LV": "/api/v1/money_returns?country_code=LV",
  "Money refund EE": "/api/v1/money_returns?country_code=EE",
  "SB Leasing ET": "/api/v1/orders/payments/upload_payments_file",
  "SB Leasing VV": "/api/v1/orders/payments/upload_payments_file",
  "DPD": "/api/v1/orders/payments/upload_payments_file",
  "LP express": "/api/v1/orders/payments/upload_payments_file",
  "Venipak": "/api/v1/orders/payments/upload_payments_file",
  "Omniva": "/api/v1/orders/payments/upload_payments_file",
  "Esto": "/api/v1/orders/payments/upload_payments_file",
  "Amazon payment": "/api/v1/orders/payments/upload_payments_file",
  "Amazon fee": "/api/v1/orders/payments/upload_payments_file",
  "ZipasGo": "/api/v1/orders/payments/upload_payments_file",
  "Klarna": "/api/v1/orders/payments/upload_payments_file",
};
export default function MoneyReturn({
  title,
  action,
  type,
  file_download = false,
}) {
  if (!action) {
    action = apis[title];
    if (["SB Leasing ET", "SB Leasing VV", "DPD", "LP express", "Venipak", "Omniva", "Esto", "Amazon payment", "Amazon fee", "ZipasGo", "Klarna"].includes(title)) {
      type = title.toLowerCase().split(" ").join("_");
    }
  }
  const onChange = (info) => {
    if (info?.file?.status == "uploading") return;
    if (info?.file?.response && info?.file?.status !== "error") {
      message.success("Import successful");
      if (file_download) {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([info.file.response])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", `Money_return.xml`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } else {
      message.error("Error occurred");
    }
  };

  const beforeUpload = () => {
    return true;
  };
  const renderImportButton = () => {
    let props = {
      name: "file",
      action,
      showUploadList: false,
      beforeUpload: beforeUpload,
      onChange: onChange,
    };
    if (type) {
      props.data = {};
      props.data.type = type;
    }

    return (
      <Upload {...props} className="float-right mr-3">
        <li className="nav-item">
          <div className={`nav-link sidebar-link subnav-item`}>
            <FiUploadCloud className="mr-3" />
            {title}
          </div>
        </li>
      </Upload>
    );
  };
  return renderImportButton();
}
